import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SummaryStepHistory } from "@routing/paths";
import { ClaimSummaryBox } from "@routing/routes/ClaimSummary/types";

export interface ClaimDocumentsState {
  files: File[];
}

const initialState: ClaimDocumentsState = {
  files: [],
};

const claimDocumentsSlice = createSlice({
  name: "claimDocuments",
  initialState,
  selectors: {
    selectClaimDocuments: (state) => state.files,
    selectClaimsDocumentsSummary: (state): ClaimSummaryBox => ({
      boxTitle: "Photos, Videos or Documents",
      navigate: SummaryStepHistory.UPLOAD_CLAIM_DOCUMENTS,
      items: state.files.map((file) => ({
        value: file,
        label: file.name,
        fullWidth: true,
      })),
    }),
  },
  reducers: {
    submitClaimDocuments: (state, action: PayloadAction<File[]>) => {
      state.files = action.payload;
    },
    resetClaimDocuments: () => initialState,
  },
});

export const {
  actions: { submitClaimDocuments, resetClaimDocuments },
  selectors: { selectClaimDocuments, selectClaimsDocumentsSummary },
} = claimDocumentsSlice;
export { initialState as claimDocumentsInitialState };
export default claimDocumentsSlice;
